<template>
  <div class="md-layout dashboard">
    <stats-form v-model="stats"/>
    <stats-result :stats="stats"/>
  </div>
</template>
<script>

import StatsForm from './StatsForm.vue';
import StatsResult from './StatsResult.vue';

export default {
  name: 'Dashboard',
  components: {
    StatsResult,
    StatsForm,
  },
  data: () => ({
    stats: null,
  }),
};

</script>

<style type="scss">
  .dashboard {
    margin: 0 1rem;
  }
</style>
